import React from 'react'
import { Routes, Route, Navigate } from "react-router-dom";
import Home from '../components/Home/Home';
import About from '../components/About/About';
import Contact from '../components/Contact/Contact';
import Shop from '../components/shop/Shop';
import Catslider from '../components/slider/Catslider';
import Finalproduct from '../components/Finalproduct/Finalproduct';

function Pageroute() {
    return (
        <>
          {/* <BrowserRouter> */}
            <Routes>
              <Route path="*">
                <Route path='*' element={<Navigate to='/' />} />
              </Route>
    
              <Route path='/'>
                <Route index element={<Home />} />
              </Route>
              <Route path='/wedding-categories'>
                <Route index element={<Catslider />} />
              </Route>
              <Route path='/shop'>
                <Route index element={<Shop />} />
              </Route>
              <Route path='/product/:productId'>
                <Route index element={<Finalproduct />} />
              </Route>

              <Route path='/about'>
                <Route index element={<About />} />
              </Route>
              <Route path='/contact'>
                <Route index element={<Contact />} />
              </Route>

            </Routes>
    
          {/* </BrowserRouter> */}
        </>
      )
}

export default Pageroute
